import { Badge, Space } from "@bedrock/components";
import React from "react";
import classNames from "classnames/bind";
import styles from "./TopTabs.less";

const cx = classNames.bind(styles);

interface TopTabsProps {
  items: {
    key: string;
    name: string;
    badge?: number;
  }[],
  activeKey: string;
  onChange: (key: string) => void;
}

export default function TopTabs(props: TopTabsProps) {
  const { items, activeKey, onChange } = props;

  const handleChange = (key: string) => {
    if (key === activeKey) return;
    onChange(key);
  }

  return (
    <Space size="xxl" className={cx('toptabs')}>
      {items?.map?.((item) => (
        <div
          key={item.key}
          className={cx('toptabs-item', { active: activeKey === item.key })}
          onClick={() => handleChange(item.key)}
        >
          {item.name}
          <Badge count={item.badge} className={cx('toptabs-item-badge')}  />
        </div>
      ))}
    </Space>
  )
}